var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.99951 1.99976 C 6.476680000000001 1.99976 1.9995100000000008 6.47693 1.9995100000000008 11.99976 C 1.9995100000000008 17.52259 6.476680000000001 21.999760000000002 11.99951 21.999760000000002 C 17.52234 21.999760000000002 21.99951 17.52259 21.99951 11.999760000000002 C 21.99951 6.476930000000003 17.52234 1.99976 11.99951 1.99976 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 15.76526 8.427 L 17.17932 9.841059999999999 L 10.99951 16.04675 L 7.292480000000001 12.33972 L 8.70654 10.92566 L 10.99951 13.218630000000001 L 15.76526 8.427 Z",
    style: {
      fill: "#FFFFFF"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessFilled);
export default __webpack_public_path__ + "static/media/Success-filled.00488deb7a60ca1509d1cc321f92f240.svg";
export { ForwardRef as ReactComponent };